import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  INIT_URL,
  SHOW_MESSAGE,
  ADD_VEHICLE_OIL_CHECK,
  EDIT_VEHICLE_OIL_CHECK,
  SINGLE_VEHICLE_OIL_CHECK,
  FETCH_VEHICLES_OIL_CHECK,
  DELETE_VEHICLE_OIL_CHECK
} from "../constants/ActionTypes";
import axios from 'util/Api'

import {GENERAL_ERROR} from "../constants/values";

export const setInitUrl = (url) => {
  return {
    type: INIT_URL,
    payload: url
  };
};

export const getVehiclesOilCheck = (postData) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    axios.post('vehicleOilCheck/all', postData
    ).then(({data}) => {
      if (data){
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: FETCH_VEHICLES_OIL_CHECK, payload: data});
      } else {
        dispatch({type: FETCH_ERROR, payload: data.error});
      }
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
};

export const addVehicleOilCheck = (postData) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    axios.post('vehicleOilCheck/add', postData
    ).then(({data}) => {
      if (data){
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: ADD_VEHICLE_OIL_CHECK, payload: data});
      } else {
        dispatch({type: FETCH_ERROR, payload: data.error});
      }
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
};

export const editVehicleOilCheck = (postData) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    axios.post('vehicleOilCheck/edit', postData
    ).then(({data}) => {
      if (data){
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: EDIT_VEHICLE_OIL_CHECK, payload: data});
      } else {
        dispatch({type: FETCH_ERROR, payload: data.error});
      }
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
};

export const singleVehicleOilCheck = (postData) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    axios.post('vehicleOilCheck/single', postData
    ).then(({data}) => {
      if (data){
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: SINGLE_VEHICLE_OIL_CHECK, payload: data});
      } else {
        dispatch({type: FETCH_ERROR, payload: data.error});
      }
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
};

export const deleteVehicleOilCheck = (postData) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    axios.post('vehicleOilCheck/delete', postData
    ).then(({data}) => {
      if (data){
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: DELETE_VEHICLE_OIL_CHECK, payload: data});
      } else {
        dispatch({type: FETCH_ERROR, payload: data.error});
      }
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
      console.log("Error****:", error.message);
    });
  }
};
